export default __webpack_public_path__ + "static/media/plier.f2cb068c.svg";